<template>
  <div class="col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2">
    <div id="environment-ribbon" :class="'banner-' + getEnvironment()">
      {{ getEnvironmentText() }}
    </div>
    <form method="#" action="#">
      <div class="card" data-background="color" data-color="blue">
        <div class="card-header">
          <h3 class="card-title pull-left">Recover Account</h3>
          <router-link class="btn btn-fill btn-wd pull-right" to="/"><i class="ti-arrow-left"></i> Back to Login</router-link>
        </div>
        <br><br>
        <div class="card-content">
          <div class="form-group">
            <label>Tribal ID <small>(Numbers Only)</small></label>
            <input type="text" placeholder="Personal Tribal ID"
            name="tribalId"
            v-validate="modelValidations.tribalId"
            v-model="model.tribalId"
            class="form-control input-no-border">
            <small class="text-danger" v-show="tribalId.invalid">
                {{ getError('tribalId') }}
            </small>
          </div>
          <div class="form-group">
            <label>Birthdate</label><br>
            <el-date-picker
              name="birthdate"
              v-validate="modelValidations.birthdate"
              v-model="model.birthdate"
              type="date"
              placeholder="YYYY-MM-DD"
              :editable="false"
              :default-value="new Date().getFullYear() - 12 + '-01-01'"
              >
            </el-date-picker>
            <small class="text-danger" v-show="birthdate.invalid">
                {{ getError('birthdate') }}
            </small>
          </div>
          <div class="form-group">
            <label>Last 4 Digits of Social Security Number</label>
            <input type="number" placeholder="XXXX"
            name="ssn"
            v-validate="modelValidations.ssn"
            v-model="model.ssn"
             class="form-control input-no-border">
            <small class="text-danger" v-show="ssn.invalid">
                {{ getError('ssn') }}
            </small>
          </div>
          <div class="form-group">
            <label>New Account Password</label>
            <div class="input-group">
              <input :type="!showPassword ? 'password' : 'text'" placeholder="Password"
              name="password"
              v-validate="modelValidations.password"
              v-model.lazy="model.password"
              class="form-control input-no-border">
              <span class="input-group-btn">
                <button @click.prevent="showPassword=!showPassword"  type="button" tabindex="-1" class="btn form-btn"
                v-html="passwordButton" >
                </button>
              </span>
            </div>
            <small class="text-danger" v-show="password.invalid">
                {{ getError('password') }}
            </small>
          </div>
          <div class="form-group">
            <label>Repeat Account Password</label>
            <input :type="!showPassword ? 'password' : 'text'" placeholder="Repeat Password"
            name="passwordRepeat"
            v-validate="modelValidations.passwordRepeat"
            v-model="model.passwordRepeat"
            class="form-control input-no-border">
            <small class="text-danger" v-show="passwordRepeat.invalid">
                {{ getError('passwordRepeat') }}
            </small>
          </div>
        </div>
        <div class="card-footer text-center">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-wd"><i class="ti-lock"></i> Recover Account</button> <br><br>
          <transition name="fade" mode="out-in"><p class="alert alert-danger" v-if="serverError">{{ serverError }}</p></transition>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { DatePicker } from 'element-ui'
  import { mapFields } from 'vee-validate'
  import viewClientMethod from 'src/components/Dashboard/Views/Dashboard/ViewClient'
  import accountSelectorMethod from 'src/components/Dashboard/Views/Home/Forms/AccountSelector'

  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    computed: {
      ...mapFields(['tribalId', 'birthdate', 'ssn', 'password', 'passwordRepeat']),
      passwordButton () {
        return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
      }
    },
    data () {
      return {
        showPassword: false,
        serverError: false,
        model: {
          tribalId: '',
          birthdate: '',
          ssn: '',
          password: '',
          passwordRepeat: ''
        },
        modelValidations: {
          tribalId: {
            required: true,
            alpha_num: true
          },
          birthdate: {
            required: true
          },
          ssn: {
            required: true,
            length: 4,
            decimal: false
          },
          password: {
            required: true,
            min: 6
          },
          passwordRepeat: {
            required: true,
            confirmed: 'password'
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.serverError = false
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('on-submit', this.model)
            this.$http.post('/client/recover', this.model)
              .then(response => {
                if (response.data.authenticated) {
                  if (response.data.accounts) {
                    this.accountSelector(response.data.accounts)
                  } else {
                    this.viewClient(response.data)
                  }
                } else {
                  this.serverError = response.data.error
                }
              })
              .catch(error => {
                console.log(error)
              })
          }
        })
      },
      viewClient: viewClientMethod,
      accountSelector: accountSelectorMethod
    },
    created: function () {
      this.viewClient = this.viewClient.bind(this)
      this.accountSelector = this.accountSelector.bind(this)
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/Forms/RecoverAccount.vue